<template>
    <div class="goods">

        <Head :headInfo='headInfo' :slotShow='appVer' @onClickLeft='onBack' @onClickRight="onShareGoods">
            <div slot='iconImg' class="iconImg">
                <img src="../../../assets/img/b2b/icon_share@2x.png" alt="" v-if="appVer">
            </div>
        </Head>
        <BannerSwiper :pageWidth='pageWidth' :imgUrlList='goods.skuPictureBoList'></BannerSwiper>
        <div class="navTitle">
            <div class="head">
                <div class="headLeft" v-if="$isPriceShow()">
                    <div class="h3" v-show="type">首单特价：</div>
                    <div class="" :class="{'price': type}"><span>¥ </span>{{ goods.salePrice }}<sub>¥ {{ goods.sellPrice}}</sub></div>
                </div>
                <div class="headLeft" v-else>
                    <div class="h3" v-show="type">首单特价：</div>
                    <div class="price">会员价<sub>¥ {{ goods.sellPrice}}</sub></div>
                </div>
                <div class="headRight">
                    <div class="describe" v-text="timeHtml"></div>
                    <div class="time">
                        <vantCountDown :underway='false' @onCountDown="onCount" :time="timeDown"></vantCountDown>
                    </div>
                </div>
            </div>
            <div class="title">
                <div class="content" v-text="goods.skuShowName"></div>
            </div>
        </div>
        <Region class="mtop20" v-if="spuSalesAreaBoList.length" :spuSalesAreaList='spuSalesAreaBoList'></Region>
        <div class="mark arrow2 mtop20 borderBotLeft0 col999" @click="onPen(1)">
            <img class="serveImg" src="../../../assets/img/b2b/icon_zp.png" alt="">正品保障&店铺售后<div class="item"></div>
        </div>
        <div class="mtop20">
            <ShopName :shopName='shopName' />
        </div>
        <div class="contentDetail mtop20">
            <v-switcher :headers="headerCenter" align="center">
                <div class="demo-item textCenter" slot="0" v-html="detail">
                </div>
            </v-switcher>
        </div>
        <div class="foot" v-if="$isApproveShow()">
            <div class="btn" :class="{'active': isStart || !goods.inventoryRemainNum}" @click="onPen(2)">立即购买</div>
        </div>
        <div class="foot" v-else>
            <div class="btn" @click="onPen(3)">认证后可购买</div>
        </div>
        <van-popup v-model="popupVisible2" position="bottom" :closeOnClickModal='false' :round="true">
            <div class="select">
                <div class="head borderBot borderBotLeft0">
                    <div class="img">
                        <img :src="picUrl" alt="">
                    </div>
                    <div class="title2">
                        <div class="close">
                            <img @click="onClose()" src="../../../assets/img/b2b/btn_delete@2x.png" alt="">
                        </div>
                        <div class="goodsBt">
                            <div class="price">
                                <sub>¥ </sub>{{ goods.salePrice | NumFormat }}
                            </div>
                            <div class="cont" v-if="goods.skuCode">
                                商品编号：{{ goods.skuCode }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rebateList" v-show="goods.skuRebateBoList && goods.skuRebateBoList.length">
                    <div class="rebateLeft">返利</div>
                    <div class="rebateRight" v-text="rebatePriceHtml"></div>
                </div>
                <div class="nums">
                    <div class="name">购买数量</div>
                    <div class="cartN">
                        <div class="xg">限购{{ goods.purchaseLimitNum }}件</div>
                        <div class="cartClass">
                            <van-stepper v-model="goods.quantity" :max='goods.inventoryRemainNum > goods.purchaseLimitNum ? goods.purchaseLimitNum : goods.inventoryRemainNum' />
                            <!-- <CartNum :listItem="goods" :disabled="true" activityString='activity' @onNumber='onNumber'></CartNum> -->
                        </div>
                        <!-- <CartControl :listItem="goods" @onNumber='onNumber' activityString='activity' :typeNum='1'></CartControl> -->
                    </div>
                </div>
                <div class="rebate f24" v-show="rebatePrice">预计可返{{ rebatePrice }}元</div>
            </div>
            <div class="lines"></div>
            <div class="fot">
                <div class="btn">
                    <div class="btn1"></div>
                    <div class="btn1 btnRed" @click="onBuy()">立即购买</div>
                </div>
            </div>
        </van-popup>
        <Server :visible.sync='popupVisible'></Server>
        <CustomerService :goodInfo='goodInfo' />
    </div>
</template>
<script>
import vantCountDown from '../common/vanCountDown'
import CustomerService from '../common/customerService'
import Head from '../../common/head'
import { Toast } from 'vant'
import { versions } from '../../common/version'
import { getInvitationCode, shopInfo } from '../api/api'
import BannerSwiper from '../common/detail/bannerSwiper' // banner详情
import Server from '../common/detail/server' // 服务协议
import Region from '../common/detail/region' // 销售区域
import ShopName from '../common/shopNameTemplate' // 小店
import { mapActions } from 'vuex'
export default {
    name: 'activityDetail',
    components: {
        Head,
        BannerSwiper,
        Server,
        Region,
        vantCountDown,
        CustomerService,
        ShopName
    },
    data () {
        return {
            headInfo: {
                title: '商品详情'
            },
            headerCenter: ['商品介绍'],
            iconShow: false,
            spikeId: this.$route.query.spikeId,
            skuId: this.$route.query.skuId,
            shopName: '',
            goods: {},
            parameterList2: [],
            bannerImgList: [],
            specifications: [],
            detail: '',
            popupVisible: false,
            popupVisible2: false,
            popupVisible3: false,
            sku: {},
            rebatePrice: 0,
            priceRebate: 0,
            rebatePriceHtml: '',
            picUrl: '',
            isStart: true,
            pageWidth: document.documentElement.clientWidth,
            timeDown: 0,
            timeHtml: '距离结束',
            userInfo: '',
            activityParams: '',
            appVer: false,
            isPrice: true,
            spuSalesAreaBoList: [],
            invitationCode: '',
            goodInfo: null,
            type: this.$route.query.type
        }
    },
    methods: {
        ...mapActions(['setActivity', 'setBuried', 'getSkuGoodsDetail', 'getRebateData', 'isPriceData']),
        onBack () {
            if (!this.$route.query.isShare) {
                if (this.goodsDetailBack) {
                    localStorage.removeItem('activityData')
                    this.$router.push({ path: this.goodsDetailBack })
                } else {
                    this.$router.go(-1)
                }
            } else {
                if (this.goodsDetailBack) {
                    this.$router.push({ path: this.goodsDetailBack })
                } else {
                    this.$router.push({ path: '/b2b/home/index' })
                }
            }
        },
        onCount () {
            this.isStart = false
        },
        async getIsPrice () {
            await this.isPriceData({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                spuId: this.goods.spuId
            }).then(data => {
                this.isPrice = data
            })
        },
        onPen (val) {
            switch (val) {
                case 1:
                    this.popupVisible = true
                    break
                case 2:
                    if (!this.isPrice) {
                        Toast('您没有权限购买此商品')
                        return false
                    }
                    if (this.isStart || !this.goods.inventoryRemainNum) {
                        return false
                    }
                    this.popupVisible2 = true
                    break
                case 3:
                    this.$router.push({ path: '/b2b/company/index' })
                    break
                default:
                    break
            }
        },
        onBuy () {
            this.activityInfo(1)
            this.popupVisible2 = false
            this.popupVisible = false
            let skuList = [{
                merchantCode: this.goods.merchantCode,
                spikeId: this.$route.query.spikeId,
                skus: [
                    {
                        skuId: this.skuId,
                        quantity: this.goods.quantity
                    }
                ]
            }]
            localStorage.setItem('goodsData', JSON.stringify(skuList))
            this.$router.push({ path: '/b2b/order/confirmOrder', query: { spikeId: this.$route.query.spikeId } })
        },
        onClose () {
            this.popupVisible = false
            this.popupVisible2 = false
            this.popupVisible3 = false
        },
        onNumber () {
            // this.getRebate()
        },
        timeString () {
            let nowtime = this.getTimeString(this.goods.nowTime)
            let startTime = this.getTimeString(this.goods.startTime)
            let endTime = this.getTimeString(this.goods.endTime)
            this.isStart = startTime < nowtime
            if (nowtime > startTime) {
                this.timeHtml = '距离结束'
                this.timeDown = endTime - nowtime
                this.isStart = false
            } else {
                this.timeHtml = '距离开始'
                this.timeDown = startTime - nowtime
                this.isStart = true
            }
        },
        getTimeString (data) {
            return new Date(data.replace(/-/g, '/')).getTime()
        },
        // async getRebate () {
        //     await this.getRebateData({
        //         skuNum: this.goods.quantity,
        //         skuId: this.goods.skuId
        //     }).then((data) => {
        //         this.rebatePrice = data.maxRebate
        //     })
        // },
        async getGoodsDetail (type) {
            await this.getSkuGoodsDetail({
                merchantCode: this.userInfo.belongMerchantCode || '',
                memberCode: this.userInfo.companyCode || '',
                skuId: this.skuId,
                spikeId: this.spikeId
            }).then((data) => {
                this.goodShow = true
                if (!data) {
                    return false
                }
                this.specifications = data.skuParameterBoList ? JSON.parse(data.skuParameterBoList) : ''
                this.spuSalesAreaBoList = data.spuSalesAreaBoList || []
                data.quantity = 1
                if (data.spuDetailList) {
                    this.detail = data.spuDetailList
                }
                if (data.skuPictureBoList) {
                    this.picUrl = data.skuPictureBoList[0]
                }
                this.goods = data
                this.goodInfo = {
                    cardImage: data.skuPictureBoList[0],
                    cardHeader: data.skuName,
                    cardSubhead: '',
                    cardPrice: '¥' + data.salePrice,
                    cardUrl: ''
                }
                this.getIsPrice()
                this.timeString()
                this.activityInfo()
                this.getShopInfo()
                this.appVer = !!localStorage.getItem('appVer')
            }, (err) => {
                if (err.response.status === 429) {
                    this.$router.push('/b2b/429')
                }
            })
        },
        activityInfo (type) {
            this.activityParams.productId = this.$route.query.skuId
            this.activityParams.productName = this.goods.skuName
            this.activityParams.activityId = this.spikeId
            localStorage.setItem('spikeData', JSON.stringify(this.activityParams))
            // 解决分享进入单分享防止埋点重复执行
            if (!type) {
                this.setActivity(this.activityParams)
            }
        },
        async buryPoint (event) {
            this.setBuried({ event: event })
        },
        onShareGoods () {
            this.buryPoint(86)
            let shareUrl = '/b2b/companyActivity/shareGoods'
            let shareTitle = this.goods.skuName
            let content = '[正品行货]' + this.goods.skuName
            let homeHtml = this.type ? 'firstOrder' : 'speedKill'
            let imgLink = this.picUrl + '?x-oss-process=image/resize,w_400,h_400/quality,Q_100'
            let urlLink = shareUrl + '?spikeId=' + this.spikeId + '&skuId=' + this.skuId + '&merchantCode=' + this.goods.merchantCode + '&isWeixin=true&type=2&invitationCode=' + this.invitationCode + '&homeType=' + this.$route.query.type
            console.log(urlLink)
            let miniprogramPath = '/goods/pages/activityDetail/index?spikeId=' + this.spikeId + '&skuId=' + this.skuId + '&sourceUserId=' + this.userInfo.id + '&type=' + homeHtml
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'activityShare',
                    'title': shareTitle,
                    'desc': content,
                    'imgLink': imgLink,
                    'urlLink': urlLink,
                    'spikeId': this.spikeId,
                    'skuId': this.skuId,
                    'miniprogramPath': miniprogramPath,
                    'miniprogramUserName': 'gh_a009e26f070f'
                })
            } else {
                window.kfxt.activityShare(shareTitle, content, imgLink,
                    urlLink,
                    this.spikeId,
                    this.skuId
                )
                window.kfxt.newActivityShare(JSON.stringify({
                    'title': shareTitle,
                    'desc': content,
                    'imgLink': imgLink,
                    'urlLink': urlLink,
                    'spikeId': this.spikeId,
                    'skuId': this.skuId,
                    'miniprogramPath': miniprogramPath,
                    'miniprogramUserName': 'gh_a009e26f070f'
                }))
            }
        },
        async getInvitationCodeData () {
            const { data } = await getInvitationCode({
                userId: this.userInfo.id
            })
            this.invitationCode = data.merchantInvitationCode
        },
        // 店铺信息
        async getShopInfo () {
            const { data } = await shopInfo({
                merchantCode: this.goods.merchantCode
            })
            this.shopName = data.shopName
        }
    },
    mounted () {
        this.activityParams = localStorage.getItem('spikeData') ? JSON.parse(localStorage.getItem('spikeData')) : {}
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.goodsDetailBack = localStorage.getItem('goodsDetailBack')
        this.tab = localStorage.getItem('tab') || 0
        this.getGoodsDetail()
        this.getInvitationCodeData()
    }
}
</script>
<style lang="scss" scoped>
.iconImg {
    height: 88px;
}
.goods {
    font-size: 28px;
    padding-bottom: 150px;
    background: #f5f5f5;
    position: relative;
    width: 100%;
    .banner {
        height: 100vw;
        position: relative;
        .banner-item {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .navTitle {
        .head {
            // height: 120px;
            // line-height: 100px;
            color: #ffffff;
            display: flex;
            justify-content: space-between;
            .headLeft {
                flex: 1;
                background: #ff4d4f;
                font-size: 48px;
                padding: 24px 0 24px 32px;
                box-sizing: border-box;
                .h3 {
                    font-size: 24px;
                    margin-bottom: 4px;
                }
                span {
                    font-size: 32px;
                }
                sub {
                    margin-left: 18px;
                    font-size: 22px;
                    text-decoration: line-through;
                }
                .price {
                    font-size: 40px;
                    span {
                        font-size: 38px;
                    }
                    sub {
                        font-size: 24px;
                    }
                }
            }
            .headRight {
                flex: 0 0 244px;
                line-height: normal;
                padding: 20px 24px;
                font-size: 22px;
                text-align: center;
                box-sizing: border-box;
                color: #000000;
                background: #ffeded;
                .describe {
                    margin-bottom: 12px;
                    position: relative;
                    padding-left: 26px;
                    &::before {
                        content: "";
                        position: absolute;
                        background: url(../../../assets/img/b2b/time2.png)
                            no-repeat;
                        background-size: 100% 100%;
                        width: 32px;
                        height: 32px;
                        left: 20px;
                        top: 0;
                    }
                }
                .time {
                    font-size: 20px;
                }
            }
        }
        .title {
            padding: 28px 96px 28px 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            background: #ffffff;
            .content {
                line-height: 42px;
                font-size: 30px;
                color: #333333;
                font-weight: 500;
                word-wrap: break-word;
                word-break: break-all;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }
        }
    }
    .mark {
        font-size: 28px;
        position: relative;
        background-color: #ffffff;
        height: 96px;
        line-height: 96px;
        padding: 0 32px;
        color: #999999;
        span {
            vertical-align: top;
            margin-left: 12px;
            color: #000;
        }
        .item {
            float: right;
            margin-right: 40px;
            width: 480px;
            color: #333333;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
        img {
            width: 32px;
            height: 32px;
            vertical-align: text-top;
            position: relative;
            top: 4px;
            margin-right: 8px;
        }
    }
    .arrAbte::after {
        position: absolute;
        content: "";
        top: 32px;
        right: 28px;
        width: 40px;
        height: 40px;
        background: url(../../../assets/img/b2b/system_help@2x.png) no-repeat;
        background-size: 100%;
    }
    .contentDetail {
        background: #ffffff;
        .demo-item {
            min-height: 200px;
            box-sizing: border-box;
        }
        .cont {
            padding: 32px;
            z-index: 99;
            .btn {
                width: 208px;
                height: 64px;
                line-height: 64px;
                font-size: 28px;
                text-align: center;
                border-radius: 64px;
                color: #ffffff;
                background: #ff4d4f;
                &.active {
                    background: #ccc;
                }
            }
        }
    }
    .foot {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #ffffff;
        padding: 32px;
        z-index: 99;
        .btn {
            width: 100%;
            height: 90px;
            line-height: 90px;
            font-size: 34px;
            text-align: center;
            border-radius: 90px;
            color: #ffffff;
            background: #ff4d4f;
            &.active {
                background: #ccc;
            }
        }
    }
}
.conpon {
    background: #ffffff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .head {
        position: relative;
        height: 108px;
        line-height: 108px;
        padding: 0 24px;
        .close {
            width: 48px;
            height: 48px;
            position: absolute;
            right: 24px;
            top: 10px;
        }
    }
    .server {
        height: 900px;
        padding: 32px;
        .ratePrice {
            margin-bottom: 80px;
        }
        .rabateSm {
            margin-bottom: 48px;
            .title {
                margin-bottom: 16px;
            }
        }
        .serveImg {
            width: 32px;
            height: 32px;
            vertical-align: sub;
            padding-right: 4px;
        }
    }
}
.select {
    padding: 24px;
    background: #ffffff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .head {
        display: flex;
        justify-content: space-between;
        position: relative;
        padding-bottom: 40px;
        .img {
            width: 220px;
            height: 220px;
            flex: 0 0 220px;
            background: #999999;
            img {
                display: inline-block;
                width: 100%;
                height: 100%;
                margin: 0 auto;
                background: #f2f3f5;
                object-fit: cover;
            }
        }
        .title2 {
            margin-left: 24px;
            flex: 0 0 460px;
            display: flex;
            align-content: space-between;
            flex-wrap: wrap;
            .close {
                flex: 0 0 100%;
                overflow: hidden;
                img {
                    width: 48px;
                    height: 48px;
                    float: right;
                }
            }
            .img {
                width: 220px;
                height: 220px;
                flex: 0 0 220px;
                background: #999999;
                img {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    margin: 0 auto;
                    background: #f2f3f5;
                    object-fit: cover;
                }
            }
            .goodsBt {
                .price {
                    flex: 0 0 100%;
                    font-size: 34px;
                    color: #ff7a45;
                    height: 48px;
                    sub {
                        font-size: 22px;
                    }
                    span {
                        font-size: 24px;
                        color: #999999;
                        margin-left: 32px;
                        text-decoration: line-through;
                        sub {
                            font-size: 16px;
                        }
                    }
                }
                .cont {
                    font-size: 24px;
                    color: #333333;
                    line-height: 36px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
                .gg {
                    font-size: 24px;
                    line-height: 30px;
                    height: 60px;
                    width: 360px;
                    margin-top: 12px;
                    color: #666666;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    word-wrap: break-word;
                    word-break: break-all;
                    overflow: hidden;
                }
            }
        }
    }
}
.rebateList {
    display: flex;
    justify-content: flex-start;
    font-size: 28px;
    padding: 32px 0;
    border-bottom: 2px solid #eeeeee;
    position: relative;
    .rebateLeft {
        flex: 0 0 144px;
        color: #333333;
    }
    .rebateRight {
        color: #999999;
        line-height: 40px;
    }
}
.rebate {
    text-align: right;
    font-size: 24px;
    margin-top: 10px;
    color: #ff7a45;
}
.nums {
    display: flex;
    justify-content: space-between;
    margin-top: 28px;
    line-height: 60px;
    .cartN {
        flex: 0 0 400px;
        position: relative;
        .xg {
            position: absolute;
            left: 60px;
            color: #ff7a45;
            font-size: 24px;
        }
    }
    .cartClass {
        float: right;
    }
    .num {
        display: flex;
        justify-content: flex-end;
        span {
            display: inline-block;
            width: 66px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            &.jian {
                background: url(../../../assets/img/b2b/btn_reduce@2x.png)
                    no-repeat;
                background-size: 100% 100%;
            }
            &.jian2 {
                background: url(../../../assets/img/b2b/btn_reduce_pre@2x.png)
                    no-repeat;
                background-size: 100% 100%;
            }
            &.jia {
                background: url(../../../assets/img/b2b/btn_add@2x.png)
                    no-repeat;
                background-size: 100% 100%;
            }
            &.w38 {
                width: 76px;
                font-size: 32px;
                background: #f5f5f5;
                margin: 0 2px;
            }
        }
    }
}
.fot {
    padding: 32px;
    background: #ffffff;
    .btn {
        display: flex;
        justify-content: space-between;
        .btn1 {
            width: 208px;
            height: 64px;
            line-height: 64px;
            border-radius: 64px;
            text-align: center;
            margin: 0 10px;
            color: #ff7a45;
            &.btnBg {
                background: #ff7a45;
                color: #ffffff;
            }
            &.btnRed {
                background: #ff4d4f;
                color: #ffffff;
            }
            &.oss2 {
                border: 0.026667rem solid #ccc;
                color: #fff;
                background: #ccc;
                width: 100%;
            }
        }
    }
}

/deep/ .v-switcher-header-anchor {
    height: 2px;
    background-color: #ff7a45;
    bottom: 0;
}
/deep/ .v-switcher-header-item.is-active {
    color: #ff7a45;
}
/deep/ .mint-swipe-indicator {
    width: 14px;
    height: 14px;
    margin: 10px;
    border-radius: 50%;
}
/deep/ .mint-swipe-indicator.is-active {
    background: #ff7a45;
}
/deep/ .v-switcher-header-item {
    width: 50%;
    font-size: 28px !important;
}
/deep/ .v-switcher-header-tabs {
    border-bottom: 1px solid #d1d1d6;
}
/deep/ .van-stepper__minus {
    width: 56px;
    height: 56px;
    padding: 8px;
}
/deep/ .van-stepper__plus {
    width: 56px;
    height: 56px;
    padding: 8px;
}
/deep/ .van-stepper__minus::before {
    width: 26px;
    height: 3px;
}
/deep/ .van-stepper__plus::before {
    width: 26px;
    height: 3px;
}
/deep/ .van-stepper__plus::after {
    width: 3px;
    height: 26px;
}
/deep/ .van-stepper__input {
    width: 64px;
    font-size: 28px;
    height: 56px;
    margin: 0 4px;
    color: #323232;
}
</style>
<style lang="scss">
body.dialog-open {
    position: fixed;
    width: 100%;
}
</style>
